export default function useFundPageURL(fpURL?: string) {
    if (!window || !fpURL || fpURL === "-") return null;
    const url = new URL(fpURL, "https://fundcentres.landg.com");
    const params = new URLSearchParams(window.location.search);
    params.delete("isin_code"); //remove ISIN as shareclass may not be child of fund
    url.search = params.toString();
    return url.toString();
}
